import { z } from 'zod'

/**
 * Mirror of the backend's TelemetryEvent model (scribbler-api/src/schemas.py).
 *
 * Strict on purpose: the backend rejects unknown fields with a 422, and telemetry
 * errors are swallowed, so a stray field would silently lose the event. Parsing here
 * turns that into a visible console warning instead, and guarantees no content field
 * (prompt text, document text) can ever be sent.
 */
export const TelemetryEventDtoSchema = z.strictObject({
  schema_version: z.string(),
  event_type: z.enum([
    'task_started',
    'task_succeeded',
    'task_failed',
    'content_inserted',
    'insertion_checked',
  ]),
  occurred_at: z.iso.datetime(),
  task_id: z.string(),
  task_type: z.enum(['chat', 'review', 'imatch']),
  app_version: z.string(),
  event_id: z.string(),
  model_version: z.string().optional(),
  document_id: z.string().optional(),
  document_type: z.string().optional(),
  asset: z.string().optional(),
  task_outcome: z.enum(['responded', 'comments_applied', 'matched', 'no_matches']).optional(),
  duration_ms: z.int().optional(),
  failure_type: z.enum(['timeout', 'network', 'api_error', 'word_error', 'other']).optional(),
  insertion_id: z.string().optional(),
  characters_inserted: z.int().optional(),
  characters_remaining: z.int().optional(),
  document_characters: z.int().optional(),
})

/** Mirror of the backend's TelemetryDocument model. Strict for the same reason as above. */
export const TelemetryDocumentDtoSchema = z.strictObject({
  schema_version: z.string(),
  source: z.enum(['word', 'upload', 'brave']),
  path: z.string().min(1).max(2048),
})
